












import {
  defineComponent,
  watch,
  getCurrentInstance,
  ref,
  onMounted,
  computed,
  reactive,
  onUnmounted,
} from '@vue/composition-api';
import _ from 'lodash';

import InviteDialog from '@/renderer/views/desktop/ManageConsole/UserManagement/innerUser/components/InviteDialog.vue';

import sidebarGuideHandler from '@/renderer/views/desktop/BaseSidebar/SidebarGuideHandler';
import user from '@/renderer/scripts/utils/user';

import guideHandler from '../composition/guideHandler';

import AdvanceGuideDialog from '../components/AdvanceDialog.vue';
import NoviceGuideCards from '../components/NoviceGuideCards.vue';
import AdminGuideCards from '../components/AdminGuideCards.vue';
import WelcomeDialog from '../components/Welcome/dialog.vue';

export default defineComponent({
  name: 'Guide',
  components: {
    AdvanceGuideDialog,
    NoviceGuideCards,
    AdminGuideCards,
    InviteDialog,
    WelcomeDialog,
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const store = vm.$store;
    const showDialog = reactive<Record<string, boolean>>({
      inviteUser: false,
      welcome: false, // 欢迎页
    });

    const showFinish = ref(false);
    const showAdvanceGuide = ref(false);
    const {
      initShow,
      showPersonalInfo,
      advanceGuideCardId,
      methods: guideMethods,
      isAdminGuide,
    } = guideHandler(showDialog);
    // 是否在新手引导中,若在新手引导中，则不允许点击菜单，直至引导结束。
    const { inGuide } = sidebarGuideHandler();

    const methods = {
      openAdvanceGuideDetail(step: number) {
        if (inGuide.value) return;
        advanceGuideCardId.value = step - 1;
        showAdvanceGuide.value = true;
        const reportMap = ['newhand_company_space', 'newhand_timing_machine', 'newhand_more'];
        store.commit('setPaySource', reportMap[step]);
        reporter.report('pay', {
          pay_source_click: reportMap[step],
        });
      },
    };

    const guideData = computed(() => store.getters.noviceGuidance);

    const guideStepAdShow = computed(
      () => guideData.value?.baseGuide?.done && store.getters.editionFlag === 'personal',
    );

    watch(guideStepAdShow, val => {
      if (val) {
        reporter.report('pay', {
          pay_source_show: 'newhand_company_space',
        });
        reporter.report('pay', {
          pay_source_show: 'newhand_timing_machine',
        });
        reporter.report('pay', {
          pay_source_show: 'newhand_more',
        });
      }
    });

    onMounted(async () => {
      // 监听团队版弹窗
      user.on('switch-org-finished', guideMethods.queryNoviceGuidance);
      await guideMethods.queryNoviceGuidance();
      if (!_.isEmpty(store.getters.noviceGuidance)) {
        initShow.value = true;
      }
    });

    onUnmounted(() => {
      user.off('switch-org-finished', guideMethods.queryNoviceGuidance);
    });

    return {
      initShow,
      showAdvanceGuide,
      showPersonalInfo,
      showFinish,
      advanceGuideCardId,
      showDialog,
      isAdminGuide,
      ...methods,
      ...guideMethods,
    };
  },
});
